<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<p class="c-text c-text--bold">{{ 'Service_Provider_Search.Description' | translate }}</p>
				<form name="vm.form" class="c-form u-ost-md">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<div class="c-form__group u-no-m">
							<label for="lang" class="c-form__label">{{ 'Services.Filter.Languages' | translate }}</label>
							<mat-select style="border: 1px solid #d1d1d1;" [(value)]="vm.selectedLangs" class="mat-select" id="lang" placeholder="{{ 'Services.Filter.Languages' | translate }}" multiple data-md-container-class="mat-select-menu2">
								<mat-option id="language{{$index}}" *ngFor="let lang of vm.searchLanguages ; let $index=index" [value]="lang">{{ ('Services.Language.' + lang) | translate }}</mat-option>
								<mat-select-trigger>{{ vm.getLanguagesText() }}</mat-select-trigger>
							</mat-select>
						</div>
						<div style="margin-top:10px !important;" class="c-form__group u-no-m" *ngIf="vm.searchTags">
	                        <label for="tags" class="c-form__label">{{ 'Services.Filter.Tags' | translate }}</label>
	                        <mat-select style="border: 1px solid #d1d1d1;" [(value)]="vm.selectedTags" class="mat-select" id="tags" placeholder="{{ 'Services.Filter.Tags' | translate }}" multiple data-md-container-class="mat-select-menu2">
	                            <mat-option id="tagOption{{$index}}" *ngFor="let tagTranslation of vm.searchTags ; let $index=index" [value]="tagTranslation.tag.name">{{ tagTranslation.translation }}</mat-option>
	                        	<mat-select-trigger>{{ vm.getTagsText() }}</mat-select-trigger>
	                        </mat-select>
	                    </div>
						<div style="margin-top:10px !important;" class="c-form__group u-no-m">
							<label for="serviceProvider" class="c-form__label">{{ 'Services.Other.Search_Placeholder' | translate }}</label>
							<input-autocomplete id="serviceProvider" [displayPlaceHolder]="true" name="serviceProvider" [(model)]="vm.formData.serviceProvider" [selectFn]="vm.handleSelect" [searchFn]="vm.handleServiceProviderSearch"></input-autocomplete>
						</div>
						<ul style="margin-top:10px;position:unset;background-color:rgb(246, 244, 244);" class="c-autocomplete__list">
							<li style="cursor:default;" class="c-autocomplete__item" *ngFor="let item of vm.items ; let $index=index" tabindex="-1">
								<div style="display:flex;flex-direction: row;align-items: stretch;">
									<div onerror="this.style.visibility='hidden'" class="c-image c-image--bg c-image--round c-image--sm" [ngStyle]="{ 'background-image': 'url(' + item.user?.profilePicture?.thumbnailUrl + ')' }" *ngIf="item.user?.profilePicture && vm.isValidPictureUrl(item.user?.profilePicture?.thumbnailUrl)"></div>
									<div class="c-image c-image--bg c-image--round c-image--sm" *ngIf="!item.user?.profilePicture?.thumbnailUrl"></div>
									<div style="margin-left:15px;flex-grow:1;align-items:center;">
										<div id="serviceProviderNameLabel">{{item.user?.firstname}} {{item.user?.lastname}}</div>
										<div>{{item.parentServiceTitle}}, {{item.occupation}}</div>
									</div>
									<button id="removeItemButton" type="button" style="position: unset;top: 0;transform: none;margin: 15px 0px 0px 10px;min-width:20px;" class="c-form__input-btn" (click)="vm.removeItem($index)">
										<i class="o-icon o-icon--x" aria-hidden="true"></i>
										<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
									</button>
								</div>
							</li>
						</ul>
					</div>
				</form>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
						<button id="serviceProviderSearchSubmitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.submit()" [disabled]="vm.processing || !vm.initialized">{{ 'Common.Send' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
